export default __webpack_public_path__ + "static/media/consult.1527f18a.jpg";